module.exports = __webpack_public_path__ + "img/wrj.39458e6d.png";